function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.376 21.6113H36.3633V27.7672H49.376V21.6113Z",
  fill: "#883883"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7701 0H21.6113V13.0127H27.7701V0Z",
  fill: "#4106E7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0127 21.6113H0V27.7672H13.0127V21.6113Z",
  fill: "#0075E7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.9704 5.05451L30.769 14.2559L35.124 18.6108L44.3253 9.40945L39.9704 5.05451Z",
  fill: "#AD0CFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.41011 5.0523L5.05518 9.40723L14.2565 18.6086L18.6115 14.2536L9.41011 5.0523Z",
  fill: "#1126FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4829 24.3567C30.4829 23.2088 30.1425 22.0866 29.5047 21.1322C28.867 20.1777 27.9605 19.4338 26.9 18.9945C25.8395 18.5553 24.6725 18.4403 23.5466 18.6643C22.4208 18.8882 21.3866 19.441 20.5749 20.2527C19.7632 21.0644 19.2105 22.0985 18.9865 23.2244C18.7626 24.3502 18.8775 25.5172 19.3168 26.5777C19.7561 27.6383 20.5 28.5447 21.4544 29.1825C22.4089 29.8202 23.531 30.1606 24.6789 30.1606C26.2182 30.1606 27.6945 29.5491 28.7829 28.4607C29.8714 27.3722 30.4829 25.896 30.4829 24.3567Z",
  fill: "#161946"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1655 16.6698V27.697H55.5347V0.00292969H65.6762C70.9229 0.00292969 74.3953 3.55157 74.3953 8.33491C74.3953 13.1182 70.9287 16.6698 65.6762 16.6698H60.1655ZM64.987 12.5786C67.9197 12.5786 69.6941 10.9597 69.6941 8.37304C69.6941 5.78634 67.9197 4.0912 64.987 4.0912H60.1655V12.5786H64.987Z",
  fill: "#161946"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M81.3489 0.00292969H76.8735V27.6882H81.3489V0.00292969Z",
  fill: "#161946"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M102.567 22.3037C101.564 25.5826 98.5934 28.2455 94.077 28.2455C88.9857 28.2455 84.4692 24.5414 84.4692 18.1744C84.4692 12.2326 88.8684 8.29688 93.6165 8.29688C99.4029 8.29688 102.799 12.1095 102.799 18.06C102.812 18.539 102.772 19.0178 102.682 19.4883H88.9476C88.9814 20.8172 89.5399 22.0787 90.5011 22.997C91.4623 23.9153 92.7479 24.4157 94.077 24.389C96.778 24.389 98.1682 22.9607 98.787 21.1072L102.567 22.3037ZM98.2825 16.2065C98.2063 14.007 96.7399 12.042 93.6547 12.042C92.5019 12.0176 91.3836 12.4357 90.5294 13.2102C89.6753 13.9847 89.1501 15.0569 89.0619 16.2065H98.2825Z",
  fill: "#161946"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M109.847 18.2212L103.133 8.92139H108.456C108.805 9.50794 112.24 14.3998 112.586 14.9394L116.677 8.92139H121.768L115.172 18.142L122 27.7116H116.753L112.392 21.4237C112.008 22.0103 108.497 27.1338 108.148 27.7116H103.016L109.847 18.2212Z",
  fill: "#161946"
});

function SvgPlexBranding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 31,
    viewBox: "0 0 122 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlexBranding);
export default __webpack_public_path__ + "static/media/plex_branding.b5985277.svg";
export { ForwardRef as ReactComponent };